<template>
  <div id="ticket_l">
    <top></top>
    <div class="main">
      <div class="content">
        <p class="ticket_l_title">审票</p>
        <div class="ticket_l_border"></div>
        <div class="ticket_l_box">
          <div
            v-for="(item, index) in items"
            :key="index"
            @click="toTargetPage(item.link_url)"
          >
            <img :src="item.icon" alt="" />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import { getmyMenu } from "@/api/api";
export default {
  name: "ticketList",
  components: { top },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.getMenuData();
  },
  methods: {
    async getMenuData() {
      let data = this.$qs.stringify({ client_mark: "declare" });
      const res = await getmyMenu(data);
      res.data.lists.forEach((item) => {
        if (item.mark === "Ticket") {
          this.items = item.children;
        }
      });
    },
    toTargetPage(link) {
      this.$router.push({
        path: link,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket_l_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  padding-left: 30px;
  box-sizing: border-box;
  color: #565b7d;
}
.ticket_l_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 30px 0;
}
.ticket_l_box {
  display: flex;
  flex-wrap: wrap;
  div {
    width: 240px;
    height: 110px;
    background-color: #f2f6fb;
    border-radius: 16px;
    padding: 27px 37px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-right: 34px;
    cursor: pointer;
    img {
      width: 56px;
      height: 56px;
      margin-right: 20px;
    }
    p {
      font-weight: 500;
    }
  }
}
</style>